import { AccountStatus, IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountPayoutReady = (account: IAccount) =>
  account.canBeUsedFor?.payouts && account.status !== AccountStatus.Inactive;
